import {useEffect , useState} from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import Dashboard from "../../components/Dashboard/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { setPensionDataRedux, setRedemptionRightDataRedux, setRightsPerEmpRedux, setSalaryDataRedux } from "../../state/actions/DashboardActions";
import {
  GetMemberDetails,
  memberDetailsUtil,
  MEMBER_QUESTIONS_NO_DATA,
} from "../../services/GetMemberDetails";
import {
  setHaveMessages,
  setIsAmit,
  setIsOnline,
  setIsPensioner,
  setIsSendAgainPossible,
  setIsSendAgainPossibleDate,
  setIsSuspend,
  setMapUserFunds,
  setUserFirstName,
  setUserFunds,
  setUserLastName,
} from "../../state/actions/UserActions";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import { GetDashboradData } from "../../services/Dashboard.service";
import { GetMemberFunds } from "../../services/GetMemberFunds";
import ErrorPopup from "../../components/ErrorPopup/ErrorPopup";
import { getUserFunds } from "../../services/getUserFunds";
import { setTokenData } from "../../services/OtpVerify";
import "./Home.css";

const AdminHome = (props) => {
  const {match} = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("common");
  const history = useHistory();
  const [inInitUserData , setinInitUserData] = useState(false);

  //console.log("match.params" , match.params , match.params?.token , match.params?.tokenNum)

  const ininitUserData = async() => {await setinInitUserData(()=>true);};

  const initUserData = async () => {
    Promise.all([GetMemberDetails(), GetMemberFunds()])
      .then(async (results) => {
        const userDetails = results[0];
        const userFundsData = results[1];
        if (
          !(memberDetailsUtil.isValid(userDetails) && userFundsData?.length)
        ) {
          if (
            userDetails === MEMBER_QUESTIONS_NO_DATA &&
            userFundsData.length
          ) {
            history.push("/privacy-questions");
          } else {
            dispatch(setModalState(true));
            dispatch(
              setModalChild(
                <ErrorPopup size="m" label={t("general.error")} center={true} />
              )
            );
            history.push("/register");
            history.push("/login");
            
          }
        } else {
          const { userFunds, isAmit, isPensioner, haveMessages } =
          await getUserFunds(userFundsData);
        //  console.log('v3' ,userFunds, isAmit, isPensioner, haveMessages )
          await dispatch(setUserFirstName(userDetails.firstName));
          await dispatch(setUserLastName(userDetails.lastName));
          let mapUserFunds =  new Map(
            userFunds.map((obj) => {
              return [obj.fundCode, obj];
            }),
          );
          await dispatch(setMapUserFunds(mapUserFunds));
          await dispatch(setUserFunds(userFunds));
          isAmit && await dispatch(setIsAmit(isAmit));
          isPensioner && await dispatch(setIsPensioner(isPensioner));
          await dispatch(setHaveMessages(haveMessages));
          await dispatch(setIsOnline(true));
          await ininitUserData()
          
          // handleDeepLinkingNav();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  useEffect(() => {
    //console.log("match.params" , match.params , match.params.token , match.params.token?.tokenNum)
    if (match.params.tokenNum) {
      sessionStorage.setItem("token", match.params.tokenNum);

      setTokenData(
        match.params.refreshTokenNum,
        match.params.tokenExpiryDate,
        match.params.refreshTokenExpiryDate
      );


      GetDashboradData().then(async (results) => {
        dispatch(setPensionDataRedux(results[0]));
        dispatch(setRedemptionRightDataRedux(results[1]));
        dispatch(setRightsPerEmpRedux(results[2]));
        dispatch(setSalaryDataRedux(results[3]));
        await initUserData();
      })
    }
  }, []);

 
  return (
    <div>
    { inInitUserData  ?
      <Dashboard /> : null }
    </div>
  );
};

export default AdminHome;
